import { CallNowRoutes } from 'app/features/call_now/routes';

const callNowRoutes = CallNowRoutes();

export { callNowRoutes };
